import template from './nodes-value-builder.html';

const nodesValueBuilderDirective = /* @ngInject */ () => ({
	scope: {
		data: '=',
		label: '@',
		tooltipText: '@',
	},
	restrict: 'E',
	template,
	replace: true,
	/**
	 * @param {any} $scope
	 */
	link($scope) {
		$scope.data = $scope.data || [];

		$scope.addValue = () => {
			$scope.data.push({});
		};

		$scope.removeValue = (/** @type {number} */ index) => {
			$scope.data.splice(index, 1);
		};

		if ($scope.data.length === 0) {
			$scope.addValue();
		}
	},
});

export default nodesValueBuilderDirective;
